import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import WarehouseAdminScreen from './Components/WarehouseAdminScreen/WarehouseAdminScreen'

const WarehouseAdmin = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <WarehouseAdminScreen className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default WarehouseAdmin